import React from 'react';
import Paper from '@material-ui/core/Paper';
import Message from 'anchor-ui/message';
import MessageList from 'anchor-ui/message-list';
//import {chat_contents} from '../../store/Store';
import DateSeparator from 'anchor-ui/date-separator';
import MessageInput from 'anchor-ui/message-input';
//import { loadMessagesList } from '../../store/Store';
import avatar from '../../store/assets/davatar.png'
//import send_icon from '../../store/send_icon.svg';

const styles = {
  Paper: {
    height: '100%',
    //borderRight: '1px solid #B5B6B5',
    //borderLeft: '1px solid #B5B6B5',
    backgroundColor: '#FFFFFF',
    position: 'relative',
    square: 'true',
    boxShadow: 'none',
    borderRight: '1px solid lightgrey',
    borderLeft: '1px solid lightgrey',
    //borderBottom: '1px solid lightgrey',
  },
  MessageList: {
    height: '91.15%',

    //
  },
  MessageInput: {
    backgroundColor: '#FEFEFE',
    marginLeft: '0%',
    marginRight: '0%',
    marginTop: '3%',
    width: '100%',
    position: 'absolute',
    boxShadow: 'none',
    border: '1px solid lightgrey',
    lineHeight: '18px',
  },
  inputStyle:{
    fontSize: 'small',
    fontFamily: 'Lucida Grande',
    lineHeight: '18px',
    paddingLeft: '15px',
    paddingRight: '15px',
  },
  OwnMessage: {
    borderRadius: '13px',
    backgroundColor: '#574871',
    textAlign: 'left',
    fontFamily: 'Lucida Grande',
    //fontSize: 'normal',
    //fontWeight: '100'
  },
  OthersMessage: {
    borderRadius: '13px',
    backgroundColor: '#F1F0F0',
    textAlign: 'left',
    fontFamily: 'Lucida Grande',
    fontSize: 'smaller',
  },
  messageTimeStyle: {
    fontSize: '10px',
    textAlign: 'left',
  },
  messageBodyStyle: {
    fontSize: '14px',
    lineHeight: '20px',
    marginTop: '-8px',
    marginBottom: '-4px',
  },
  DateSeparator: {
  },
  DateSeparatorText: {
    color: '#999999',
    backgroundColor: '#FEFEFE',
    fontSize: '12px',
  }
}

class Chat extends React.Component{
  constructor(props){
    super(props)
    this.state = {
      uid: '',
      value: '',
      //username: '',
      //messages: '',
      //chat_contents: []
    }
    //var chatSeparator = ''
  }

  // This is called by both enter and click
  handleSendMessage = () => {
    // Assuming there is a function/prop which actually sends the message
    const { sendMessage } = this.props;
    
    // Grab input value from state. This is set by handleChange
    const { value } = this.state;
    if (value){
      sendMessage(value);
      this.setState({value: ''})
    }
  }

  handleChange = (event) => {
    this.setState({
      value: event.currentTarget.value
    });
  }

  getmessageSeparator = (separator) => {
    if (this.chatSeparator === separator){
      return null
    }
    this.chatSeparator = separator
    return separator
  }

  // scrollToBottom = () => {
  //   this.messagesEnd.scrollIntoView({ behavior: "smooth" });
  // }
  
  // componentDidMount() {
  //   this.scrollToBottom();
  // }
  
  // componentDidUpdate() {
  //   this.scrollToBottom();
  // }

  render() {
    const { value } = this.state;
    
    return (
      <Paper style={styles.Paper}>
          {this.props.allMessages ? <MessageList autoScroll={true} style={styles.MessageList}>
            {
              this.props.allMessages.map((item, index) =>
                <Message style={ item.is_admin ? styles.OwnMessage : styles.OthersMessage}
                    key={index}
                    emoji={true}
                    enableMultiline={true}
                    avatar={!item.is_admin? item.avatar: avatar}
                    username = ''
                    body={item.message}
                    myMessage={item.is_admin}
                    createdAt={item.createdAt.time}
                    separator={item.createdAt.date ? <DateSeparator date = {this.getmessageSeparator(item.createdAt.date)} style={styles.DateSeparator} textStyle={styles.DateSeparatorText}/> : null}
                    messageBodyStyle={styles.messageBodyStyle}
                    messageTimeStyle={styles.messageTimeStyle}
                    enableLinks={true}
                  />
              )
            }
          {/* <div style={{ float:"left", clear: "both" }}
             ref={(el) => { this.messagesEnd = el; }}>
          </div> */}
          </MessageList> : null}
          

          {this.props.allMessages ? <MessageInput
            multiLine={true}
            placeholder="Type your answer here..."
            value={value}
            style={styles.MessageInput}
            inputStyle={styles.inputStyle}
            maxLength={10000}
            maxRows={8}
            onChange={this.handleChange}
            sendMessage={this.handleSendMessage}
            //rowHeight='18'
            // sendIcon='SEND '
          /> : null}
      </Paper>
    )
  }
}

export default Chat


// WEBPACK FOOTER //
// ./src/Components/Dashboard/Chat.js